export default "__VITE_ASSET__Bos4NhP1__"